import { render, staticRenderFns } from "./24HEmergency.vue?vue&type=template&id=0c052837"
import script from "./24HEmergency.vue?vue&type=script&lang=js"
export * from "./24HEmergency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports